// AuthContext.js
import React, { createContext, useEffect, useState, useMemo } from "react";
import axiosInstance from "../api/axios";
import { useNavigate, useLocation } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Function to refresh user data
  const refreshUserData = async () => {
    try {
      const response = await axiosInstance.get("/userdata");
      setUserData(response.data[0]);
      setRefresh(false);
    } catch (error) {
      console.error("Error refreshing user data:", error);
      if (error.response?.status === 401) {
        /* token is invalid → log out */
        localStorage.clear();
        // localStorage.setItem("extension", "approved");

        if (location.pathname !== "/") {
          navigate("/", { replace: true }); // soft redirect (no hard reload)
        }
      }
    }
  };

  useEffect(() => {
    if (refresh) {
      refreshUserData();
      setRefresh(false);
    }
  }, [refresh]);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }
    refreshUserData();
  }, []);
  const memoizedUserData = useMemo(() => userData, [userData]);
  return (
    <AuthContext.Provider
      value={{
        userData: memoizedUserData,
        setRefresh,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
